








import { Component, Mixins, Prop, Watch, Inject } from "vue-property-decorator";
import { BrowserUtility, BrowserKinds } from "../../../utilities";
import { PdfViewType } from "../../../domain/configuration";
import { IPdfViewerVisibleControl } from "../../../domain/system";

@Component
export default class PdfPluginViewer extends Mixins() {
  @Inject({ default: null })
  parentModal: symbol;

  @Prop()
  src: string;

  @Prop({ default: 1 })
  page: number;

  @Prop({ default: "Fit" })
  view: "" | "Fit" | "FitH" | "FitV";

  @Prop({ default: 0 })
  zoom: number;

  /** PdfjsViewerと合わせるために追加しているが未使用 */
  @Prop()
  forceEnableOpenTypeFontFace: boolean;

  data(): any {
    return {
      isLoaded: true,   // TODO: Loading実装しようとしたがobjectタグによるPDF表示時はloadeddata等のイベントは発生しない模様.代替案検討要.(別途取得してbase64変換したものを渡すようにする？)
      shownSource: this.$props.src,
    };
  }
  isLoaded: boolean;
  shownSource: string;

  private get pdfViewerVisibleControlObjects(): IPdfViewerVisibleControl[] {
    return (this.$store.state.pdfViewerVisibleControlObjects);
  }

  get shownPluginSource(): string {
    // IEのPDFプラグイン(Adobe製)の表示を制御するパラメータを追加.
    // ・ページサイズに合わせる.
    // ・ツールバーを非表示に.(未指定だとなぜか2回目以降はツールバーが表示されてしまう.)
    // ・pageはviewより先に指定する必要あり
    return this.shouldShow
      ? this.shownSource + "#page=" + this.defaultPage + this.viewSource + this.zoomSource + "&pagemode=none&scrollbar=1&toolbar=0&statusbar=0&messages=0&navpanes=0"
      : "";
  }

  get shouldShow(): boolean {
    return !!this.shownSource // !!付けないと、shownSourceがnullの時、戻り値はnullになる模様.(v-ifはtrueじゃないと正常に処理しないようで、正確にtrueを返す必要あり.
      && (this.shownSource !== "");
  }

  get defaultPage(): number {
    return this.page > 1
      ? this.page
      : 1;
  }

  get viewSource(): string {
    if (this.pdfRenderingViewType) { 
      return typeof this.pdfRenderingViewType !== "number"
        ? "&view=" + this.pdfRenderingViewType
        : "";
    }
    return this.view !== "" && this.zoom === 0
      ? "&view=" + this.view
      : "";
  }

  get zoomSource(): string {
    if (this.pdfRenderingViewType) { 
      return typeof this.pdfRenderingViewType === "number"
        ? "&zoom=" + this.pdfRenderingViewType
        : "";
    }
    return this.view === "" && this.zoom > 0
      ? "&zoom=" + this.zoom
      : "";
  }

  get pdfRenderingViewType(): PdfViewType {
    return this.$configuration.system.pdfRendering.viewType;
  }

  get isVisiblePreview(): boolean {
    // IE以外は常に表示してよし。
    if (BrowserUtility.getBrowserKind() !== BrowserKinds.InternetExplorer) { return true; }
    // モーダル使用中は最後に積まれたものが親と一致する場合表示する
    const controls = this.pdfViewerVisibleControlObjects;
    if (controls.length === 0) {
      return true;
    }
    if (controls[controls.length - 1].symbol === this.parentModal) {
      return !controls[controls.length - 1].isTransparent;
    }
    const filtered = controls.filter(v => !v.isTransparent);
    return filtered.length === 0
      ? true
      : filtered[filtered.length - 1].symbol === this.parentModal;
  }

  @Watch("src")
  onSourceUpdated(newValue: string, oldValue: string): void {
    // IEのPDFプラグインはobject/@dataを更新しても表示を更新しない模様.
    // v-ifで1度objectをDOMから削除して再度追加する事で表示を強制的に更新する.
    this.shownSource = null;
    this.$nextTick(() => {
      this.shownSource = newValue;
    });
  }
}
